import React, { ReactElement } from "react";
import JoinBeta from "@components/site/JoinBeta/JoinBeta";

export const JoinBetaPage = ({ referer }) => {
    // console.debug("beta/galxe - referer: ", referer);
    const subtitle = (
        <>
            Start trading NFTs on&nbsp;
            <strong>God Mode.</strong>
        </>
    );
    return (
        <>
            <JoinBeta subtitle={subtitle} callToAction="Claim your spot:" referer={referer} />
        </>
    );
};

export async function getServerSideProps(context) {
    // console.debug(`req headers: `, context?.req?.headers);

    return {
        props: {
            referer: context?.req?.headers?.referer ? context?.req?.headers?.referer : null,
        },
    };
}

JoinBetaPage.getLayout = function getLayout(page: ReactElement) {
    return <>{page}</>;
};

export default JoinBetaPage;
